import { State } from '../State';
import { ProductId } from '../iap';
import { assertNever } from '../utils';
import { duration } from '../utils/duration';
import {
  PetStarterPackProductId,
  StarterPackProductId,
  petStarterPackProducts,
} from './starterpack.ruleset';

/**
 * The duration of the starter pack promo
 */
const starterPackPromoDuration = duration({ days: 7 });

/**
 * Check if the starter pack promo is enabled for the user
 * @param state
 * @returns
 */
export function isPetStarterPackEnabled(state: State): boolean {
  // Disable starter pack feature for now, it can changed soon
  // But we should use feature() next time
  return false;
}

/**
 * Check if a product is a pet starter pack product
 * @param id
 * @returns
 */
export function isPetStarterPackProduct(id: ProductId): boolean {
  return petStarterPackProducts.includes(id as PetStarterPackProductId);
}

/**
 * Retrieve the remaining time for the starter pack promo
 * @param state
 * @param now
 * @returns
 */
export function getRemainingStarterPackPromoTime(
  state: State,
  now: number,
): number {
  const promoStartTime = state.match2.shopBundles?.petStarterPackStartedAt ?? 0;
  // If the promo has not started yet, just return 0 as it should not be available
  if (promoStartTime === 0) return 0;
  const elapsed = now - promoStartTime;
  return starterPackPromoDuration - elapsed;
}

/**
 * Retrieve the product id based on the user's AB test bucket
 * @returns
 */
export function getStarterPackProductId(
  state: State,
): StarterPackProductId | undefined {
  const bucket = 'control';

  switch (bucket) {
    case 'control':
    case null:
      // No product for the control bucket
      return undefined;
    default:
      assertNever(bucket);
  }
}
